import React, { CSSProperties } from "react";
import { Input } from "antd";
import "./DefaultInput.css";

interface IDefaultInput {
	label?: string;
	placeholder?: string;
	width?: number;
	value?: any;
	onChange?: (value: any) => void;
	allowClear?: any;
	className?: any;
	prefix?: any;
	suffix?: any;
	addonBefore?: any;
	type?: "text" | "password" | "number";
	required?: boolean;
	disabled?: boolean;
	ref?: any;
	min?: number;
	underLabel?: string;
	status?: any;
	onBlur?: any;
	style?: CSSProperties;
}

const DefaultInput = ({
	label,
	placeholder,
	width,
	value,
	onChange,
	allowClear,
	className,
	prefix,
	suffix,
	type = "text",
	addonBefore,
	required,
	disabled = false,
	ref,
	min,
	underLabel,
	onBlur,
	status,
	style,
}: IDefaultInput) => {
	const numberInputOnWheelPreventChange = (e: any) => {
		e.target.blur();

		e.stopPropagation();

		setTimeout(() => {
			e.target.focus();
		}, 0);
	};
	return (
		<div className="flex flex-col items-start gap-1">
			<label className="w-42 -mb-1">{label}</label>
			{underLabel && (
				<label className="w-42" style={{ fontSize: 12 }}>
					{underLabel}
				</label>
			)}
			<Input
				type={type}
				placeholder={placeholder}
				value={value}
				onChange={onChange}
				allowClear={allowClear}
				className={`default-input ${className}`}
				prefix={prefix}
				suffix={suffix}
				addonBefore={addonBefore}
				required={required}
				disabled={disabled}
				min={min}
				ref={ref}
				onBlur={onBlur}
				status={status}
				style={style}
				//@ts-ignore
				onWheel={numberInputOnWheelPreventChange}
			/>
		</div>
	);
};

export default DefaultInput;
